/* @ngInject */
export default function WeatherGridFactory(uiGridConstants) {

  /**
   * @param {Function} sortingAlgorithm - the algorithm used in columnDefs[2]
   * @returns {object} configuration for uiGrid
   */
  return sortingAlgorithm => ({
    minRowsToShow: 3,
    enableFiltering: true,
    enableRowSelection: true,
    enableRowHeaderSelection: true,
    enableFullRowSelection: true,
    enableSelectAll: false,
    showGridFooter: false,
    multiSelect: true,
    enableColumnResizing: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    columnDefs: [{
      field: 'name',
      displayName: 'Name',
      cellTooltip: true,
      type: 'string',
      enableHiding: false,
      sort: {
        direction: uiGridConstants.ASC,
        priority: 2
      }
    }, {
      field: 'settings.cameraRegion',
      displayName: 'Region',
      cellTooltip: true,
      enableHiding: false,
      type: 'string',
      sort: {
        direction: uiGridConstants.ASC,
        priority: 1
      }
    }, {
      field: 'id',
      displayName: 'Event Count',
      type: 'number',
      enableHiding: false,
      sortingAlgorithm,
      cellTemplate:
          `<div style="padding: 5px">
            {{grid.appScope.weatherPanelModel.eventCounter[row.entity.id]}}
          </div>`,
      sort: {
        direction: uiGridConstants.DESC,
        priority: 0
      }
    }, {
      field: 'hoursRemaining',
      cellClass(__, row) {
        return row.entity?.disable?.status ? 'equipment-disabled' : '';
      },
      displayName: 'Disabled Time',
      enableHiding: false,
      type: 'string'
    }],
    data: [/* temp data array */]
  });
}
